import styled from 'styled-components';
import { AppStyledProps } from '../../../../../types';

type T = AppStyledProps;

export const TableStyled = styled.table<T>`
  position: relative;
  margin: auto;

  td,
  tr {
    padding: 0.5em 1em;
  }
`;
